export default "__VITE_ASSET__3uXuMlYK__"